import { Injectable, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { MessageService, ConfirmationService } from 'primeng/api';
import * as moment from 'moment-timezone';
import { RxMethods } from './rxjs.service';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/auth/auth.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class Utils implements OnDestroy {
  private selectedRows: any = {};
  private canShowNativeConfirmDialog: Subject<any>;
  constructor(private messageService: MessageService,
    private rxMethods: RxMethods,
    private router: Router,
    private authService: AuthService,
    private confirmationService: ConfirmationService,
    private ngxService: NgxUiLoaderService) { }

  ngOnDestroy(): void {
    this.canShowNativeConfirmDialog.unsubscribe();
  }

  showNotification(message: string, action: string, summary: string) {
    if (action === 'error') {
      this.confirmationService.confirm({
        message: message,
        header: 'Alert !',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: 'OK',
        rejectVisible: false,
      });
    } else
      this.messageService.add({ severity: action, summary: summary, detail: message, life: 10000 });
  }

  clearNotification() {
    this.messageService.clear();
  }

  findSelectedDDValueById(ddSource: object[], controlId: string, value: any) {
    let ddItems = this.rxMethods.pluck(ddSource, controlId);
    ddItems = ddItems.length > 0 ? ddItems[0] : [];
    const item = ddItems.find((elem) => elem.id === value);
    if (item) {
      item.select = true;
    }
    return item;
  }

  updateForm(formGroup: FormGroup, controlId: string, value: any, isDropDown: boolean, ddSource: object[]) {
    if (isDropDown) {
      const selectedItem = this.findSelectedDDValueById(ddSource, controlId, value);
      formGroup.controls[controlId].patchValue(selectedItem);
    } else {
      formGroup.controls[controlId].patchValue(value);
    }
    return formGroup;
  }

  constructFormControlGroup(source: any[], savedData?: object, ddSource?: object[],
    isUpdate?: boolean, formGroup?: FormGroup, isGrid?: any) {
    const formControls = {};
    let formData;
    source.forEach(
      (element) => {
        if (element.type === 'button') { return; }
        if (isGrid && !savedData.hasOwnProperty(element.id)) { return; }

        let controlValue = (savedData && (savedData[element.id] || savedData[element.id] === 0)) ? savedData[element.id] : '';
        controlValue = controlValue === 'false' ? false : controlValue;
        const controlId = element.id;

        if (element.type === 'checkbox') {
          controlValue = (controlValue === '') ? false : (controlValue === 'true') ? true : controlValue;
        }

        if (element.type === 'picker' && element.pickerType === 'calendar' && controlValue) {
          const dateSplitValues = controlValue.split('/');
          controlValue = new Date(+dateSplitValues[2], +dateSplitValues[1] - 1, +dateSplitValues[0]);
        }

        if (element.type === 'picker' && element.pickerType === 'timer' && controlValue) {
          const date = new Date();
          const time = controlValue.split(':');
          controlValue = new Date(+date.getFullYear(), +date.getMonth(), +date.getDate(), +time[0], +time[1]);
        }

        if (element.type === 'picker' && element.pickerType === 'both' && controlValue) {
          const dateArray = controlValue.split(' ');
          const dateParts = dateArray[0] ? dateArray[0].split('/') : '';
          const timeParts = dateArray[1] ? dateArray[1].split(':') : '';

          controlValue = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0], timeParts[0], timeParts[1]);
        }
        if (isUpdate) {
          if (element.type === 'multiselect') {
            formGroup.controls[controlId].patchValue(controlValue);
          } else if (element.type === 'search' && (!controlValue)) {
            element['filteredData'] = element.datasource;
            formData = this.updateForm(formGroup, controlId, controlValue, (!!element.datasource), ddSource);
          } else if (element.type === 'search' && (controlValue)) {
            const ddSourceList = this.pluckValues(ddSource, controlId)[0];
            element['filteredData'] = ddSourceList && ddSourceList.length ? ddSourceList : element.datasource;
            element['datasource'] = ddSourceList && ddSourceList.length ? ddSourceList : element.datasource;
            formData = this.updateForm(formGroup, controlId, controlValue, (!!element.datasource), ddSource);
          } else if (element.type === 'label') {
            element.labelText = controlValue;
          } else if (element.type === 'buttonEvent') {
          } else {
            formData = this.updateForm(formGroup, controlId, controlValue, false, ddSource);
          }
        } else {
          if (element.type === 'label') {
            element.labelText = controlValue;
          } else {
            formControls[controlId] = new FormControl({ value: controlValue, disabled: element.isDisabled }, element.validations);
            if (element.type === 'search') {
              // element.datasource = element.datasource ? element.datasource : [];
              element.enableVirtualScroll = !!((element.datasource ? element.datasource.length : 0) > 250);
             // element.enableVirtualScroll = !!(element.datasource.length > 250);
              element['filteredData'] = element.datasource;

              if (controlValue) {
                const selectedItem = this.findSelectedDDValueById(ddSource, controlId, controlValue);
                // element.defaultValue = selectedItem ? selectedItem : element.defaultValue;
              }
            }
          }
          formData = new FormGroup(formControls);
        }
      });
    return formData;
  }

  insertIdFieldInDataSource(data: any, recStatus?: string, setSelectFalse?: boolean) {
    data.map((elem: object, index: number) => {
      elem['recStatus'] = recStatus ? recStatus : '';
      elem['cueRowId'] = index + 1;
      elem['id'] = index + 1;

      if (setSelectFalse) {
        elem['select'] = false;
      }
    });
    return data;
  }

  setComboValueForRequestData(formData: object, canSkipDateFormat?: boolean) {
    const formDataObj = Object.assign({}, formData);
    for (const form in formDataObj) {
      if (!Number.isInteger(parseFloat(formDataObj[form]))) {
        if (formDataObj[form]) {
          if (!canSkipDateFormat && formDataObj[form] instanceof Date) {
            formDataObj[form] = moment(formDataObj[form]).format('DD/MM/YYYY');
          } else if ((!Array.isArray(formDataObj[form])) && typeof formDataObj[form] === 'object' && !(formDataObj[form] instanceof Date)) {
            formDataObj[form] = formDataObj[form].id;
          }
        }
      }
    }
    return formDataObj;
  }

  constructRequestDataGridArray(gridArray: any) {
    if (gridArray.length > 0) {
      let gridArrayTemp = JSON.parse(JSON.stringify(gridArray));
      gridArrayTemp.forEach((elem: object) => {
        this.mapRequestDataArray(elem);
      });
      return gridArrayTemp;
    }
    else {
      this.mapRequestDataArray(gridArray);
      return gridArray;
    }
  }

  findAndSetGridSource(gridArray, id) {
    return gridArray && gridArray.length ? this.rxMethods.pluck(gridArray, id)[0] : [];
  }

  pluckValues(gridArray, id) {
    return this.rxMethods.pluck(gridArray, id);
  }

  mapRequestDataArray(requestData) {
    for (const key in requestData) {
      if (requestData[key] instanceof Date) {
        requestData[key] = moment(requestData[key]).format('DD/MM/YYYY');
      } else
        if (requestData[key] && typeof requestData[key] === 'object') {
          requestData[key] = requestData[key].id;
        }
    }

    return requestData;
  }

  getActivatedRouteTabIndex(tabs, path: string) {
    const found = tabs.findIndex(function (el) {
      return el.path === path;
    });
    return found;
  }

  mapArrayToGridDropdowns(template: any, comboSource: any, gridArray: any, reqMatConfigs?: any) {
    const editorControls = {};
    template.forEach((element: any) => {
      let comboListItem = this.rxMethods.pluck(comboSource, element['comboId'])[0];
      if (element.editor && element.editor.params && element.editor.params.component) {
        // const control = {
        //   [element.id]: ''
        // }
        // element.editor.params.configs.formGroup = this.constructFormControlGroup([element], control, null, null, null, true);
        comboListItem = comboListItem ? comboListItem : [];
        if (element && element.editor && element.editor.collection) {
          element.editor.collection = comboListItem;
        }
        if (element && element.filter) {
          element.filter.collection = comboListItem;
        }

        gridArray.forEach((row) => {
          if (element.editor.params.configs.type === 'datePicker') {
            element.editor.params.configs.model = row[element.field];
          } else if (comboListItem && row[element.field] && !row[element.field].id) {
            const elem = comboListItem.find((item) => item.id === row[element.field]);
            row[element.field] = elem;
            editorControls[element.id] = elem;
            element.editor.params.configs.model = elem;
          }
        });
      }
    });
  }

  mapArrayToFormDropdowns(filtertemplate, comboSource) {
    filtertemplate.forEach((element: any, index: number) => {
      const comboListItem = this.rxMethods.pluck(comboSource, element.id);
      if (comboListItem.length) {
        filtertemplate[index].datasource = comboListItem[0];
        filtertemplate[index].filteredData = comboListItem[0];
      }
    });
  }

  findItemFromComboSource(comboSource, controlId, field, value) {
    let item: any;
    const comboList = this.rxMethods.pluck(comboSource, controlId)[0];
    item = comboList.find((elem) => elem[field] === value);
    return item;
  }

  getUniqueArray(arr, comp) {
    const unique = arr
      .map(e => e[comp])
      // store the keys of the unique objects
      .map((e, i, final) => final.indexOf(e) === i && i)
      // eliminate the dead keys & store unique objects
      .filter(e => arr[e]).map(e => arr[e]);

    return unique;
  }

  setSelectedRows(rows) {
    if (!rows) {
      this.selectedRows = {};
      return;
    }

    for (const key in rows) {
      if (this.selectedRows[key]) {
        this.selectedRows[key] = rows[key];
      } else {
        this.selectedRows[key] = rows[key];
      }
    }
  }

  getSelectedRowsId(selectedRow, key) {
    let ids = [];
    selectedRow.forEach(element => {
      ids.push(element[key]);
    });
    return ids;
  }

  getSelectedRows(key) {
    return this.selectedRows[key] ? this.selectedRows[key] : [];
  }

  applyDatasourceinTemplate(templateSource: any[], ddSource, isGrid = false, gridArray?: any[]) {
    templateSource.forEach(
      (element) => {
        let currentDropdownObj = ddSource.find(value => { return value[element.id] });
        currentDropdownObj = currentDropdownObj ? currentDropdownObj[element.id] : []
        if (isGrid) {
          if (element.type === 23 || element.filter) {
            element.editor.collection = currentDropdownObj;
            element.editor.collectionAsync = currentDropdownObj;
            element.filter.collection = currentDropdownObj;
            element.filter.collectionAsync = currentDropdownObj;
            if (gridArray && gridArray.length > 0) {
              gridArray.forEach((row) => {
                if (row[element.field] && !row[element.field].id) {
                  row[element.field] = currentDropdownObj.find((item) => item.id === row[element.field]);
                }
              });
            }
          }
        }
        else {
          if (element.type === 'search') {
            element.datasource = currentDropdownObj;
          }
        }
      });
  }

  addTimetoDate(date: Date, hours: number, mins: number) {
    let dateValue = new Date(date);
    dateValue.setHours(hours);
    dateValue.setMinutes(mins);
    return dateValue;
  }

  routeToScreen(targetScreen) {
    this.router.navigate[targetScreen];
  }

  constructRequestData(reqParams, workFlowName, methodName) {
    return {
      'workFlowName': workFlowName,
      'processType': 'Screen',
      'workFlowParams': JSON.stringify({
        'methodName': methodName,
        'strToken': this.authService.getAuthorizationToken(),
        'strUserId': this.authService.getLoggedUserName(),
        ...reqParams
      })
    };
  }

  formatDate(date, format?: string, timezone?: string) {
    if (!date) { return; }
    let dateParts, dateObject;
    if (date instanceof Date) {
      dateObject = date;
    } else if (typeof date === 'number') {
      dateObject = new Date(date);
    } else {
      dateParts = date.split('/');
      const time = dateParts[2] ? dateParts[2].split(' ') : '';
      if (time.length > 1) {
        const timeParts = time[1].split(':');
        dateObject = new Date(time[0], dateParts[1] - 1, +dateParts[0], timeParts[0], timeParts[1], timeParts[2] ? timeParts[2] : '00');
      } else {
        dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
      }
    }
    // return dateObject && format ? moment(dateObject).format(format) : dateObject;
    if(timezone){
      return dateObject && format ? moment(dateObject).tz(timezone).format(format) : dateObject;
    }else{
      return dateObject && format ? moment(dateObject).format(format) : dateObject;
    }
    
  }

  getMinsSecs(value) {
    let time;
    if (value instanceof Date) {
      value = moment(value).format('HH:mm');
    }
    time = value.split(':');
    return {
      minutes: time[0],
      seconds: time[1]
    };
  }

  constructAvailableVehiclePayload(planDate, formData, vehicleType, scope) {
    const startMinutes = formData['strStartTime'] ? this.getMinsSecs(formData['strStartTime']) : '00:00';
    const sHours = startMinutes['minutes'] ? startMinutes['minutes'] : '00';
    const sSeconds = startMinutes['seconds'] ? startMinutes['seconds'] : '00';
    const startDate = (planDate + ' ' + sHours + ':' + sSeconds);
    const dropMinutes = formData['strEndTime'] ? this.getMinsSecs(formData['strEndTime']) : '23:59';
    const eHours = dropMinutes['minutes'] ? dropMinutes['minutes'] : '00';
    const eSeconds = dropMinutes['seconds'] ? dropMinutes['seconds'] : '00';
    const endDate = (planDate + ' ' + eHours + ':' + eSeconds);

    return {
      'startDate': startDate,
      'endDate': endDate,
      'advance': {
        'truckType': vehicleType
      }
    };
  }

  findDifference(array1, arra2, key) {
    return array1.filter(function (o1) {
      // filter out (!) items in result2
      return !arra2.some(function (o2) {
        return o1[key] === o2[key];          // assumes unique id
      });
    });
  }

  setInSessionStore(key, value) {
    sessionStorage.setItem(key, JSON.stringify(value));
  }

  getSessionStoreItem(key) {
    return JSON.parse(sessionStorage.getItem(key));
  }

  deleteItemFromSession(key) {
    sessionStorage.removeItem(key);
  }

  downloadSystemFile(url, filename) {
    let link = document.createElement("a");
    link.download = filename;
    link.href = url;
    link.click();
    link.remove();
  }

  startProgress() {
    this.ngxService.start();
  }

  stopProgress() {
    this.ngxService.stop();
  }

  constructMultiselectDataForGrid(gridArray, isInit, field) {
    gridArray.forEach((elem) => {
      if (elem[field]) {
        elem[field] = isInit ? elem[field].split(',') : elem[field].toString();
      }
    });
    return gridArray;
  }

  getLastDayInMonth(date, on, format) {
    // Start: startOf, End: endOf
    return moment(date)[on]('month').format(format);
  }

  getMonths(isWithYear: boolean, noOfMonths?: number, isIdWithNoYear?: boolean, canCapitaliseId?: boolean) {
    const mom = moment.locale("en");
    const months = moment.monthsShort();
    const monthYear = [];
    if (isWithYear) {
      for (let i = 0; i < noOfMonths; i++) {
        const monthObj = moment().add(i, 'months');
        const month = monthObj.format('MMM');
        const year = monthObj.format('YYYY');
        let id = isIdWithNoYear ? month : (month + '-' + year);
        id = canCapitaliseId ? id.toUpperCase() : id;
        monthYear.push({ id: id, value: (month + '-' + year) });
      }
    }
    return monthYear.length ? monthYear : months;
  }

  getMonthsInDriver(isWithYear: boolean, noOfMonths?: number, isIdWithNoYear?: boolean, canCapitaliseId?: boolean) {
    const mom = moment.locale("en");
    const months = moment.monthsShort();
    const monthYear = [];
    if (isWithYear) {
      for (let i = 1; i < noOfMonths; i++) {
        const monthObj = moment().subtract(i, 'months');
        const month = monthObj.format('MMM');
        const year = monthObj.format('YYYY');
        let id = isIdWithNoYear ? month : (month + '-' + year);
        id = canCapitaliseId ? id.toUpperCase() : id;
        monthYear.push({ id: id, value: (month + '-' + year) });
      }
    }
    return monthYear.length ? monthYear : months;
  }

  bindMultiselectObj(value, dataSource, key) {
    const selectedValue = value ? value.split(',') : [];
    const selectedItems = [];
    selectedValue.forEach((value) => {
      const item = dataSource.find((elem) => elem[key] === value);
      selectedItems.push(item);
    });
    return selectedItems;
  }

  removeExistingItemInDest(source: any[], dest: any[], key?: string) {
    source.forEach((srcElem) => {
      const destIndex = dest.findIndex((destElem) => destElem[key] === srcElem[key]);
      if (destIndex > -1) {
        dest.splice(destIndex, 1);
      }
    });
    return dest;
  }

  markPassDetails(passDetails, scope, canShowStartStop) {
    passDetails.forEach((elem, index) => {
      let infoMessage;
      if (elem.noShowLoc) {
        const markerIcon = (elem.inTime ? 'inLoc' : (elem.outTime ? 'outLoc' : (elem.noShowLoc ? 'noShowLoc' : '')));
        const noShowPos = elem[markerIcon] ? elem[markerIcon].split(',') : '';
        const markerType = scope.gmapService.passDetailsIcon['noShowLoc'];
        const marker = {
          latitude: parseFloat(noShowPos[0]),
          longitude: parseFloat(noShowPos[1])
        };
        marker['color'] = 'blue';
        marker['scaledSize'] = { x: 55, y: 65 };
        marker['anchor'] = { x: 30.7, y: 65.5 };
        marker['markerType'] = true;
        marker['strokeColor'] = '#145b16';
        marker['rotation'] = 0;
        const infoMessage = '<b>Passenger Name: </b>' + (elem.passName ? elem.passName : '') + '<br>' + (elem.noShowLoc ? '<br><b>No show location: </b> ' + elem.noShowLoc + ', <br> No Show Time: ' + elem.noShowTime : '');
        this.addMarker(marker, index, markerType, infoMessage, 'passDetails', scope);
      } else if (elem.inTime || elem.outTime) {
        const postionFields = [{ 'outLoc': elem.outTime, 'label': 'Out Time' }, { 'inLoc': elem.inTime, 'label': 'In Time' }];
        postionFields.forEach((element) => {
          const key = Object.keys(element)[0];
          const position = elem[key] ? elem[key].split(',') : '';
          const marker = {
            latitude: parseFloat(position[0]),
            longitude: parseFloat(position[1])
          };
          const markerType = scope.gmapService.passDetailsIcon[key];
          infoMessage = '<b>Passenger Name: </b>' + (elem.passName ? elem.passName : '') + '<br><b>' + element.label + ': </b> ' + element[key];
          marker['scaledSize'] = { x: 55, y: 65 };
          marker['anchor'] = { x: 30.7, y: 65.5 };
          marker['markerType'] = true;
          marker['strokeColor'] = '#145b16';
          marker['rotation'] = 0;
          this.addMarker(marker, 1, markerType, infoMessage, key, scope);
        });
      }
    });

    if (!canShowStartStop) { return; }

    let markerType = scope.gmapService.passDetailsIcon['startTrip'];
    let coordinates = passDetails[0].startTrip ? passDetails[0].startTrip.split(',') : '';
    let marker = {
      latitude: parseFloat(coordinates[0]),
      longitude: parseFloat(coordinates[1]),
      rotation: 0,
      scaledSize: 28,
      anchor: { x: 15.7, y: 23 },
      markerType: true,
      strokeColor: ''
    };
    if (passDetails[0].startTrip) {
      const infoMessage = '<h4><b>Start Trip</b></h4><br>Start Time: ' + (passDetails[0].jpStart ? passDetails[0].jpStart : passDetails[0].pickupPoint);
      this.addMarker(marker, 0, markerType, infoMessage, 'passDetails', scope);
    }

    if (passDetails[0].viaTrip) {
      markerType = scope.gmapService.passDetailsIcon['viaTrip'];
      coordinates = passDetails[0].viaTrip ? passDetails[0].viaTrip.split(',') : '';
      marker = {
        latitude: parseFloat(coordinates[0]),
        longitude: parseFloat(coordinates[1]),
        rotation: 0,
        scaledSize: 28,
        anchor: { x: 15.7, y: 23 },
        markerType: true,
        strokeColor: ''
      };
      const infoMessage = '<h5><b>Via: </b></h5> <br>' + passDetails[0].viaPoint;
      this.addMarker(marker, 0, markerType, infoMessage, 'passDetails', scope);
    }

    markerType = scope.gmapService.passDetailsIcon['endTrip'];
    coordinates = passDetails[0].endTrip ? passDetails[0].endTrip.split(',') : '';
    marker = {
      latitude: parseFloat(coordinates[0]),
      longitude: parseFloat(coordinates[1]),
      rotation: 0,
      scaledSize: 28,
      anchor: { x: 15.7, y: 23 },
      markerType: true,
      strokeColor: ''
    };
    if (passDetails[0].endTrip) {
      const infoMessage = '<h4><b>End Trip: </b></h4> <br> Trip End Time: ' + (passDetails[0].jpEnd ? passDetails[0].jpEnd : passDetails[0].dropPoint);
      this.addMarker(marker, 0, markerType, infoMessage, 'passDetails', scope);
    }
  }

  addMarker(marker, index, markerIcon, infoMessage, category, scope) {
    const coordinates = {
      category: category,
      lat: marker.latitude,
      lng: marker.longitude,
      id: index,
      infoWindow: infoMessage,
      label: '',
      icon: markerIcon,
      rotation: marker.rotation ? marker.rotation : 0,
      markerType: true,
      scaledSize: marker.scaledSize,
      anchor: marker.anchor ? marker.anchor : { x: 0, y: 0 },
      markerColor: marker.strokeColor ? marker.strokeColor : '#fff',
      size: marker.size ? marker.size : 20,
      canAddCluster: false
    };
    scope.gmapCallbacks['addMarker'](coordinates, {}, scope.gmapCallbacks['scope'], true);
  }

  markViolations(violations, scope) {
    const violationText = {
      'Seat Belt': 'Duration: ',
      'Harsh Braking': 'Count: ',
      'Harsh Acceleration': 'Count: ',
      'Over Speed': 'Count: '
    };
    violations.forEach((elem, index) => {
      if (elem.latitude && elem.longitude) {
        const markerType = scope.gmapService.violationIcons[elem.eventname];
        const infoMessage = '<b>Event:</b> ' + elem.eventname + ', <br>' + '<b>Start Date:</b> ' + this.formatDate(elem.startdate, 'DD/MM/YYYY HH:mm:ss') + ', <br> <b>End Date:</b> ' + this.formatDate(elem.enddate, 'DD/MM/YYYY HH:mm:ss');
        elem.anchor = { x: 15, y: 15 };
        elem.scaledSize = 40;
        this.addMarker(elem, index, markerType, infoMessage, 'violation', scope);
      }
    });
  }

  getDistanceMatrix(origin, destination, callback) {
    const service = new google.maps.DistanceMatrixService(); // instantiate Distance Matrix service
    const matrixOptions: any = {
      origins: origin, // technician locations
      destinations: destination, // customer address
      travelMode: 'DRIVING',
      unitSystem: google.maps.UnitSystem.METRIC
    };
    // Call Distance Matrix service
    service.getDistanceMatrix(matrixOptions, callback);
  }

  setGridHeight(isWithSearchParam) {
    const tabElem = document.getElementsByClassName('ui-tabview-nav')[0];
    const titleElem = document.getElementsByClassName('title_block')[0];
    const btnContainer = document.getElementsByClassName('group_btn ')[0];
    let accHeader, accContent;
    if (isWithSearchParam) {
      accHeader = document.getElementsByClassName('ui-accordion-header')[0];
      accContent = document.getElementsByClassName('ui-accordion-content-wrapper')[0];
    }
    const num = document.documentElement.offsetHeight - ((tabElem ? tabElem['offsetHeight'] : 0) +
      (titleElem ? titleElem['offsetHeight'] : 0) + (btnContainer ? btnContainer['offsetHeight'] : 0) +
      (isWithSearchParam ? 227 : 150) +
      (isWithSearchParam ? ((accHeader ? accHeader['offsetHeight'] : 0) + (accContent ? accContent['offsetHeight'] : 0)) : 0));
    return num;
  }

  setHideParentCondirmDialog(canShow) {
    this.canShowNativeConfirmDialog.next(canShow);
  }

  getHideParentCondirmDialog() {
    return this.canShowNativeConfirmDialog;
  }

  subscribeParentConfirmDialog() {
    this.canShowNativeConfirmDialog = this.rxMethods.createSubjectService();
  }

  unSubscribeParentConfirmDialog() {
    this.canShowNativeConfirmDialog.unsubscribe();
  }

  getCoords(polygon) {
    const paths = polygon;
    let latLngs;
    for (const key in paths) {
      if (paths[key] && Array.isArray(paths[key])) {
        for (let i = 0; i < paths[key].length; i++) {
          const arr = paths[key][i];
          if (arr.lat) {
            latLngs = paths[key];
          } else {
            for (const k in arr) {
              const ka = arr[k];
              if (ka && Array.isArray(ka)) {
                for (let j = 0; j < ka.length; j++) {
                  const latLngPath = ka[j];
                  if (latLngPath.lat) {
                    latLngs = ka;
                    break;
                  }
                }
              }
              if (latLngs) {
                break;
              }
            }
          }
          if (latLngs) {
            break;
          }
        }
      }
      if (latLngs) {
        break;
      }
    }
    return latLngs;
  }
}
